"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.testId = exports.keyPrefix = exports.vertical = exports.horizontal = exports.radioType = exports.classes = void 0;
var classes = {
  radioContainer: 'radio-container',
  radioContainerVertical: 'radio-container-vertical',
  radioBtnStyle: 'bds-radio-btn',
  labelContainer: 'label-container',
  disableLabel: 'disable-label',
  horizontalAlign: 'horizontal-align',
  verticalAlign: 'vertical-align',
  mainLabel: 'main-label',
  bdsRadioGroup: 'bds-radio-group',
  bdsRadioCustomBtn: 'bds-radio-custom-btn'
};
exports.classes = classes;
var radioType = 'radio';
exports.radioType = radioType;
var horizontal = 'horizontal';
exports.horizontal = horizontal;
var vertical = 'vertical';
exports.vertical = vertical;
var keyPrefix = 'radio-item-';
exports.keyPrefix = keyPrefix;
var testId = 'radio-group';
exports.testId = testId;